<template>
<v-form ref="form" v-model="valid">
  <v-container fluid v-if="!isMobile">
    <nav>
<v-app-bar app>
      <v-toolbar-title><v-breadcrumbs
      :items="items"
      large
    ></v-breadcrumbs></v-toolbar-title>
    </v-app-bar>
  </nav>

    <v-card-title>Meter</v-card-title>
    <v-card>
    <v-row>
        <v-col cols="4">
          <v-subheader style="color:red">Last Updated: {{ formatDate(meter[0].updatedAt) }}</v-subheader>
          <v-subheader style="color:red">Created By: {{ meter[0].createdBy }}</v-subheader>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Latest Meter Number Input</v-subheader>
        </v-col>
        <v-col cols="1">
           <v-text-field v-model="meter[0].meter" readonly> </v-text-field>
        </v-col>
        <v-col cols="1">
           <v-checkbox
      v-model="checkbox"
      label="Change ?"
      class="shrink mr-0 mt-0"
    ></v-checkbox>
        </v-col>
        <v-col cols="1" v-if="checkbox === true">
           <v-text-field v-model="newMeter" :rules="meterRules"> </v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-subheader>Kilowatt-Hour Bind Number</v-subheader>
        </v-col>
        <v-col cols="1">
           <v-text-field v-model="meter[0].kwh" readonly> </v-text-field>
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()" v-if="checkbox === true">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn fixed dark fab bottom right color="red" @click="goHome" v-if="checkbox === false">
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
  </v-container>

  <v-container v-else>
   

    <v-card-title>General</v-card-title>
    <v-card>
    <v-row>
        <v-col>
          <v-subheader style="color:red">Last Updated: {{ formatDate(meter[0].updatedAt) }}</v-subheader>
          <v-subheader style="color:red">Created By: {{ meter[0].createdBy }}</v-subheader>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-subheader>Latest Meter Number Input: {{meter[0].meter}}</v-subheader>
        </v-col>
        <v-col>
          <v-subheader>Kilowatt-Hour Bind Number: {{meter[0].kwh}}</v-subheader>
        </v-col>
        <v-col>
           <v-checkbox
      v-model="checkbox"
      label="Change ?"
      class="shrink mr-0 mt-0"
    ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="checkbox === true">
           <v-subheader><v-text-field v-model="newMeter" :rules="meterRules"> </v-text-field></v-subheader>
        </v-col>
      </v-row>
   </v-card>

     <v-btn fixed dark fab bottom right color="blue" @click="saveItem()" v-if="checkbox === true">
        <v-icon>mdi-content-save</v-icon>
      </v-btn>
      <v-btn fixed dark fab bottom right color="red" @click="goHome" v-if="checkbox === false">
        <v-icon>mdi-cancel</v-icon>
      </v-btn>
  </v-container>
</v-form>
</template>


<script>
import axios from "axios";
import router from "../../router";
import moment from 'moment';

export default {
  data() {
    return {
    items: [
        {
          text: 'Dashboard',
          disabled: false,
          href: '/',
        },
        {
          text: 'Settings',
          disabled: true,
          href: '',
        },
        {
          text: 'Meter',
          disabled: true,
          href: '/meter',
        }
      ],
    lastKwh: [],
    meter: [],
    isMobile: true,
    newMeter: '',
    checkbox: false,
    valid: true,
    serialNumber: [],
    locationItem: [], 
    showDeleteDialog: false,
    meterRules: [
        v => !!v || 'Device Type is required',
      ],

    };
  },
  created(){
      this.loadsMeter();
      setInterval(this.loadsKwh, 1000);
      this.onResize();
      window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.isMobile = window.innerWidth < 700;
    },
    goHome() {
      router.push("/");
    },
    formatDate(value) {
    return moment(value).format("D MMM YYYY, h:mm:ss a")
    },
    loadsKwh: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/cms-meter-now";
    axios.get(apiURL).then(res => {
    this.lastKwh = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    loadsMeter: async function(){
    let apiURL = process.env.VUE_APP_API + "/api/meter";
    axios.get(apiURL).then(res => {
    this.meter = res.data;
    }).catch(error => {
        console.log(error)
    });
    },
    async saveItem() {
      if (this.$refs.form.validate()) {
      let apiURL = process.env.VUE_APP_API + "/api/update-meter/" + "63169b5641eb587a522cf9c8";
      axios
        .post(
      apiURL,
          {
    meter: this.newMeter,
    totalPhase: this.meter[0].totalPhase,
    kwh: this.lastKwh[0].fields.totalPhase,
    createdBy: this.$keycloak.tokenParsed.given_name,
          });
    }
     router.push({ path: '/'}) 
      }
    },
  beforeDestroy() {
    if (typeof window !== "undefined") {
      window.removeEventListener("resize", this.onResize, { passive: true });
    }
  },
  };
</script>